"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHttpProviders = exports.getNetworkTransactions = exports.updateMaxBalance = exports.updateFee = exports.updateAmount = exports.getAvailableLiquidity = exports.updateFromInfo = exports.updateToInfo = exports.swapToAndFromToken = exports.resetUserProfile = exports.getUserProfile = exports.loadUserProfileDetails = exports.loadWalletDefaults = void 0;
const walletApplicationWrapperSlice_1 = require("./walletApplicationWrapperSlice");
const serverRequest = __importStar(require("../../../common-client/axiosApiClient"));
const walletApplicationWrapperHelper_1 = require("../walletApplicationWrapperHelper");
const { actions } = walletApplicationWrapperSlice_1.applicationWrapperSlice;
const loadWalletDefaults = (groupId, existingTokenList) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    //load bridge group info
    const groupInfo = yield serverRequest.loadGroupInfo(groupId);
    //load bridge global token listing
    let tokenList = [];
    console.log("existingTokenList?.length", existingTokenList === null || existingTokenList === void 0 ? void 0 : existingTokenList.length);
    if (existingTokenList === null || existingTokenList === void 0 ? void 0 : existingTokenList.length) {
        tokenList = existingTokenList.slice();
    }
    else {
        tokenList = yield serverRequest.getTokenList();
        tokenList.push({
            address: "0xb521dce1c2352664caa56efd9fe4cd9fb624e269",
            chainId: 26261,
            name: "Algo Crucible Test Token",
            symbol: "ACTT",
            decimals: 18,
            logoURI: "https://imgur.com/WiobKnJ.png",
            currency: "ALGORAND:0xb521dce1c2352664caa56efd9fe4cd9fb624e269",
        }, {
            address: "0xb745416db47c4f8c19da25c576e07488b76bbedb",
            chainId: 26261,
            name: "Algo Crucible Test Token",
            symbol: "ACTT",
            decimals: 18,
            logoURI: "https://imgur.com/WiobKnJ.png",
            currency: "ALGORAND:0xb745416db47c4f8c19da25c576e07488b76bbedb",
        }, {
            address: "0xb745416db47c4f8c19da25c576e07488b76bbedb",
            chainId: 26261,
            name: "Algo Crucible Test Token",
            symbol: "ACTT",
            decimals: 18,
            logoURI: "https://imgur.com/WiobKnJ.png",
            currency: "RINKEBY:0xb745416db47c4f8c19da25c576e07488b76bbedb",
        }, {
            address: "0xb521dce1c2352664caa56efd9fe4cd9fb624e269",
            chainId: 26261,
            name: "Algo Crucible Test Token",
            symbol: "ACTT",
            decimals: 18,
            logoURI: "https://imgur.com/WiobKnJ.png",
            currency: "BSC_TESTNET:0xb521dce1c2352664caa56efd9fe4cd9fb624e269",
        });
        console.log("tokenList.length", tokenList.length);
    }
    // const tokenList = existingTokenList?.length
    //   ? existingTokenList
    //   : await serverRequest.getTokenList();
    //load bridge group currencies token configuration
    const currencyPairs = yield serverRequest.getTokenConfigsForGroup(groupInfo === null || groupInfo === void 0 ? void 0 : groupInfo.bridgeCurrencies);
    //calculate filtered listing
    const filteredAssets = (0, walletApplicationWrapperHelper_1.getFilteredAssets)(tokenList, groupInfo === null || groupInfo === void 0 ? void 0 : groupInfo.bridgeCurrencies);
    const supportedNetworks = groupInfo === null || groupInfo === void 0 ? void 0 : groupInfo.bridgeCurrencies.map((c) => c.split(":")[0]);
    const supportedCurrencies = groupInfo.bridgeCurrencies.map((c) => c.split(":")[1]);
    dispatch(actions.walletApplicationDefaultsLoaded({
        groupInfo,
        tokenList,
        currencyPairs,
        filteredAssets,
        supportedNetworks,
        supportedCurrencies,
    }));
});
exports.loadWalletDefaults = loadWalletDefaults;
const loadUserProfileDetails = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    // const [client, connect, currencyList, api, provider] =
    //       inject5<UnifyreExtensionWeb3Client, Connect, CurrencyList, ApiClient, Web3ModalProvider>(
    //           UnifyreExtensionWeb3Client, Connect, CurrencyList, ApiClient, 'Web3ModalProvider');
    // connect.setProvider(provider);
    // const net = await connect.getProvider()!.netId();
    // console.log(net);
});
exports.loadUserProfileDetails = loadUserProfileDetails;
const getUserProfile = (userProfile) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const authToken = yield serverRequest.signInToServer(userProfile.userId);
    // console.log(
    //   "sign to server successfull user token authToken : ",
    //   authToken
    // );
    // console.log({ userProfile, authToken });
    dispatch(actions.walletApplicationUser({ userProfile, authToken }));
});
exports.getUserProfile = getUserProfile;
const resetUserProfile = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch(actions.resetWalletApplicationUser());
});
exports.resetUserProfile = resetUserProfile;
const swapToAndFromToken = (toAndFromTokens) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch(actions.swapToAndFromToken(toAndFromTokens));
});
exports.swapToAndFromToken = swapToAndFromToken;
const updateToInfo = (toInfo) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch(actions.updateToInfo({ toInfo }));
});
exports.updateToInfo = updateToInfo;
const updateFromInfo = (fromInfo) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch(actions.updateFromInfo(fromInfo));
});
exports.updateFromInfo = updateFromInfo;
const getAvailableLiquidity = (targetNetwork, targetCurrency, authToken) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    yield serverRequest
        .getAvailableLiquidity(targetNetwork, targetCurrency, authToken)
        .then((response) => {
        dispatch(actions.availableLiquidity({ availableLiquidity: response }));
    })
        .catch((err) => {
        // console.log(err);
    });
});
exports.getAvailableLiquidity = getAvailableLiquidity;
const updateAmount = (amount) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch(actions.updateAmount({ amount }));
});
exports.updateAmount = updateAmount;
const updateFee = (fee) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch(actions.updateFee({ fee }));
});
exports.updateFee = updateFee;
const updateMaxBalance = (maxBalance) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch(actions.updateMaxBalance({ maxBalance }));
});
exports.updateMaxBalance = updateMaxBalance;
const getNetworkTransactions = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const transactionResponse = yield serverRequest.getNetworkTransactions();
    dispatch(actions.getNetworkTransactions({
        networkTransactions: transactionResponse.data,
    }));
});
exports.getNetworkTransactions = getNetworkTransactions;
const getHttpProviders = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const providers = yield serverRequest.getHttpProviders();
    dispatch(actions.httpProviders({ providers }));
});
exports.getHttpProviders = getHttpProviders;
//# sourceMappingURL=walletApplicationWrapperActions.js.map